import React, { useState, useEffect, useRef,Component,createRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { CSVLink, CSVDownload } from 'react-csv'

import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, Upload,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    LoadingOutlined
} from '@ant-design/icons';





import moment from 'moment'



const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

// console.log(ClassicEditor.builtinPlugins.map( plugin => plugin.pluginName ));


const Index = ({values,datePickerValue,name}) => { 
    
    const dispatch = useDispatch()    
    const csvlinkRef = createRef()
    const { } = useSelector(
      state => ({
      
      }),
      shallowEqual
    )

    const [loading, setLoading] = useState(false)
 

    const [formattedItems, setFormattedItems] = useState([])

    useEffect(() => {
      // console.log('values',values)
      if(values.length >0){
        exportOrders()
      }
    }, [values])
    useEffect(() => {
      if(formattedItems.length > 0 && loading){
        setLoading(false)
      }
    }, [formattedItems])




    const exportOrders = () =>{
      setLoading(true)
     

 
      setFormattedItems(values)

    }   
   


    const headers = [
      { label: "category", key: "category_name" },
      { label: "product", key: "product_name" },


      { label: "quantity", key: "total_wasted" },

      { label: "unit", key: "unit" },
      
   
    ];

    const simualteClick = () =>{
      console.log(datePickerValue,name)
      if(formattedItems.length > 0 && !loading){
        setLoading(false)
        csvlinkRef.current.click()
      }


    }   


    return ( 
      <>

      <div style={{display:'hidden'}} >        
        <CSVLink  data={formattedItems} filename={`${name} product summary ${moment(datePickerValue[0]).format('LL')}-${moment(datePickerValue[1]).format('LL')}.csv`}  target="_blank" headers={headers}   
      
        > 
          <div ref={csvlinkRef} style={{display:'hidden'}}></div></CSVLink>
      </div>

      <Button onClick={()=>{simualteClick()}} disabled={values.length < 1} style={{marginRight:'1rem'}} type={'primary'} loading={loading}>Export CSV</Button>

      </>
     )
}
  
export default Index
  